// @flow
import * as React from 'react'
import styled from 'styled-components'
import { config, Hidden, Visible } from 'react-awesome-styled-grid'
import { currentUser } from '@services/firebaseAuth'
import type { AppStateType } from '@reducers/appstate'
import { useSelector } from 'react-redux'
import { isFavoriteAsync, toggleFavoriteAsync } from '../../models/Favorites'
import type { UserType } from '../../flowTypes'
import HeartOutlineIcon from '@components/shared/icons/HeartOutlineIcon'
import HeartFilledIcon from '@components/shared/icons/HeartFilledIcon'

const OutlineHeart = (): React.Node => <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
  <circle cx="24" cy="24" r="24" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd"
        d="M19.2835 17.7934C18.837 17.7934 18.4216 17.8706 18.0579 18.0015C16.632 18.5149 15.7465 19.86 15.7465 21.512C15.7465 25.1419 19.0353 28.3997 22.8435 32.1723C23.2228 32.5482 23.6099 32.9317 23.9997 33.3214C24.3896 32.9313 24.7769 32.5477 25.1564 32.1716C28.9643 28.3993 32.253 25.1417 32.253 21.512C32.253 19.8609 31.3721 18.5162 29.9544 18.0026C28.6144 17.5172 26.5647 17.7681 24.8312 19.9261L23.9967 20.9653L23.1657 19.9233C21.9133 18.3524 20.4857 17.7934 19.2835 17.7934ZM23.9996 36.4001L23.2405 35.6288C22.6064 34.9841 21.9651 34.349 21.3451 33.7346C17.189 29.6176 13.5996 26.0617 13.5996 21.512C13.5996 18.9089 15.0332 16.7758 17.3408 15.9447C19.5985 15.132 22.0645 15.7809 24.002 17.6365C25.9502 15.7798 28.4209 15.1313 30.675 15.9473C32.9724 16.7795 34.3996 18.9115 34.3996 21.512C34.3996 26.0615 30.8104 29.6169 26.6547 33.7342C26.0345 34.3486 25.3931 34.9839 24.7585 35.6288L23.9996 36.4001Z"
        fill="#F2472A"/>
</svg>

const FilledHeart = (): React.Node => <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
  <circle cx="24" cy="24" r="24" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd"
        d="M23.9996 36.4002L23.2406 35.6289C22.6064 34.9842 21.9652 34.3491 21.3452 33.7347C17.189 29.6176 13.5996 26.0617 13.5996 21.512C13.5996 18.9089 15.0332 16.7758 17.3408 15.9447C19.5986 15.132 22.0645 15.7809 24.002 17.6365C25.9502 15.7798 28.4209 15.1313 30.675 15.9473C32.9725 16.7795 34.3997 18.9115 34.3997 21.512C34.3997 26.0615 30.8105 29.617 26.6548 33.7343C26.0346 34.3486 25.3931 34.984 24.7585 35.6289L23.9996 36.4002Z"
        fill="#F2472A"/>
</svg>
type PropsType = {
  favorited: boolean
}
export function FavoriteButtonComponent (props: PropsType): React.Node {
  return (
    <FavoriteButtonContainer>
      <Hidden xs={true} sm={false}>
        {!props.favorited && <OutlineHeart/>}
        {props.favorited && <FilledHeart/>}
      </Hidden>
      <Visible xs={true} sm={false}>
        {!props.favorited && <HeartOutlineIcon/>}
        {props.favorited && <HeartFilledIcon/>}
      </Visible>
    </FavoriteButtonContainer>
  )
}

export function FavoriteButton (props: {trackId: string}): React.Node {
  const [isVisible, setIsVisible] = React.useState<boolean>(false)
  const [isFavorite, setIsFavorite] = React.useState<boolean>(false)
  const user = useSelector((state: AppStateType): UserType => state.user)
  React.useEffect((): void => {
    if (currentUser()) {
      setIsVisible(true)
      isFavoriteAsync(props.trackId).then((result: boolean): void => {
        setIsFavorite(result)
      })
    }
  }, [user])
  if (!isVisible) {
    return null
  }
  const toggleFavorite = (): void => {
    setIsFavorite(!isFavorite)
    toggleFavoriteAsync(props.trackId)
  }
  return <div onClick={toggleFavorite}><FavoriteButtonComponent favorited={isFavorite}/></div>
}

const FavoriteButtonContainer = styled.div`
    display: flex;
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
